import { useEffect, useMemo, useState } from "react"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { Input } from "../../../components/ui/input"
import { RoundedButton } from "../../../components/ui/roundButton"

const toApiPayload = ({ name, words }) => {
  const raw = Array.isArray(words) ? words.join(",") : words || ""
  return {
    name: name?.trim(),
    words: raw
      .split(",")
      .map((w) => w.trim())
      .filter(Boolean),
  }
}

const validateFields = ({ name, words }) => {
  const errors = []

  if (!name?.trim()) {
    errors.push("Nome não pode ser vazio.")
  }

  const hasWords = Array.isArray(words) ? words.length > 0 : Boolean(String(words || "").trim())
  if (!hasWords) {
    errors.push("Lista de palavras não pode ser vazia.")
  }

  return errors
}

const RestrictedWordsModal = ({
  open,
  onClose,
  onSubmit,
  initialValue,
  submitLabel = "Salvar",
}) => {
  const [name, setName] = useState(initialValue?.name || "")
  const [words, setWords] = useState(initialValue?.words || "")

  useEffect(() => {
    if (!open) return

    setName(initialValue?.name || "")
    setWords(initialValue?.words || "")
  }, [open, initialValue])

  const errors = useMemo(() => validateFields({ name, words }), [name, words])

  const handleSubmit = () => {
    if (errors.length > 0) return

    onSubmit({
      ...initialValue,
      ...toApiPayload({ name, words }),
    })
  }

  return (
    <DefaultModal
      open={open}
      handleClose={onClose}
      title="Palavras-chave"
      maxWidth="xs"
      action={
        <div style={{ display: "flex", gap: 12 }}>
          <RoundedButton rounded="outlined" onClick={onClose} sx={{ flex: 1 }}>
            Cancelar
          </RoundedButton>
          <RoundedButton onClick={handleSubmit} disabled={errors.length > 0} sx={{ flex: 1 }}>
            {submitLabel}
          </RoundedButton>
        </div>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Nome</span>
          <Input
            value={name}
            onChange={({ target }) => setName(target.value)}
            placeholder="Defina um nome para a lista"
          />
        </label>

        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Lista de palavras-chave</span>
          <textarea
            value={words}
            onChange={({ target }) => setWords(target.value)}
            placeholder="Separe as palavras por vírgulas"
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-base outline-none placeholder:text-muted-foreground"
          />
        </label>

        {/*{errors.length > 0 ? (
          <div className="scout-inline-feedback" style={{ marginTop: 0 }}>
            {errors.map((error, index) => (
              <div key={index}>{error}</div>
            ))}
          </div>
        ) : null}*/}
      </div>
    </DefaultModal>
  )
}

export default RestrictedWordsModal
